import Snackbar from '../Snackbar';

export default class ImageWithLink extends Snackbar {
  static templateId = 'image-with-link';

  static elements = [
    'imageContainer',
    'image',
    'detailsContainer',
    'textContainer',
    'linkContainer',
  ];

  constructor(...args) {
    super(...args);
    this.prepare();
  }

  prepare() {
    const { text, link, image } = this.options;

    this.textContainer.textContent = text;
    this.linkContainer.href = link.href;
    this.linkContainer.textContent = link.text;
    this.image.src = image;

    return this;
  }
}
